import {InjectionToken} from '@angular/core';
import {CustomerContactModel} from 'app/domain/customer-masterdata/data/models/customer-contact.model';
import {All, Create, Delete, Find, Update, Where} from 'app/shared/data/crud.interface';

/**
 * Repository für die Ansprechpartner eines Kunden
 */
export type CustomerContactRepository =
  & Find<CustomerContactModel>
  & All<CustomerContactModel>
  & Where<CustomerContactModel>
  & Create<CustomerContactModel, CustomerContactModel>
  & Update<CustomerContactModel, CustomerContactModel>
  & Delete;

// InjectionToken für das CustomerContactsRepository
export const CUSTOMER_CONTACT_REPOSITORY =
  new InjectionToken<CustomerContactRepository>('CUSTOMER_CONTACT_REPOSITORY');
